import { useCallback, useEffect, useRef } from 'react';

export function useDebouncedCallback<A extends any[]>(callback: (...args: A) => void, wait: number, dependencies: any[] = []) {
    const callbackRef = useRef(callback);
    const timerRef = useRef<NodeJS.Timeout>();
    const lastCallTime = useRef<number>(0);

    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return useCallback(
        (...args: A) => {
            const now = Date.now();
            lastCallTime.current = now;
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => {
                if (lastCallTime.current === now) {
                    callbackRef.current(...args);
                }
            }, wait);
        },
        [wait]
    );
}
